import { Box, Paper, Typography } from "@mui/material";
import { NotificationsNoneOutlined } from "@mui/icons-material";
import { Button, PageHeader } from "@components/ui_v2";
import { BadgeNumber } from "@components/ui_v2/incomeProfile";
import { STATUS_CATALOG } from "@helpers/constantes";
import useLoanStatusPolling from "@hooks/useLoanStatusPolling";
import useSignOut from "@hooks/useSignOut";

/** Qué pasa mientras la solicitud está en revisión; aplica a cualquier producto. */
const PASOS = [
  {
    title: "Revisión de tu información",
    sub: "Un analista revisa la información de tu solicitud y tu historial de buró.",
  },
  {
    title: "Contacto, si hace falta",
    sub: "Si necesitamos algún dato o documento adicional, un ejecutivo te llamará.",
  },
  {
    title: "Respuesta",
    sub: "Te enviaremos por WhatsApp y correo tu oferta o el resultado de tu solicitud.",
  },
];

/**
 * La solicitud pasó a revisión del equipo de crédito (status `CREVC`). Basada en `S_MCRevision` del
 * diseño, con el texto sin mencionar el producto para que sirva a cualquier empresa. Como la sala de
 * espera, sondea la solicitud y navega sola cuando el backend decide (oferta o rechazo).
 */
export const SolicitudEnRevision = () => {
  const { signOutAndRedirect, isSigningOut } = useSignOut();
  useLoanStatusPolling(STATUS_CATALOG.waiting_room_revision.code, "SolicitudEnRevision");

  return (
    <Box>
      <PageHeader
        eyebrow="Resultado · En revisión"
        title="Tu solicitud está en revisión"
        subtitle="Necesitamos una revisión adicional de nuestro equipo de crédito antes de emitir tu oferta. Por ahora no tienes que hacer nada más."
      />

      <Paper variant="lendia_paper" sx={{ textAlign: "center", p: "36px 24px" }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: "tokens.surface2",
            color: "primary.dark",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <NotificationsNoneOutlined sx={{ fontSize: 26 }} />
        </Box>
        <Typography
          sx={{ fontFamily: "Outfit", fontSize: 19, fontWeight: 600, letterSpacing: "-0.01em", color: "primary.dark" }}
        >
          En revisión del equipo de crédito
        </Typography>
        <Typography variant="body2" color="tokens.textTertiary" sx={{ mt: 0.75, mb: "22px", lineHeight: 1.55 }}>
          Respuesta en un máximo de 48 horas hábiles.
        </Typography>

        <Box
          sx={{ textAlign: "left", display: "flex", flexDirection: "column", gap: "14px", maxWidth: 440, mx: "auto" }}
        >
          {PASOS.map((paso, index) => (
            <Box key={paso.title} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
              <BadgeNumber n={index + 1} />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "primary.dark", lineHeight: 1.4 }}>
                  {paso.title}
                </Typography>
                <Typography variant="body2" color="tokens.textTertiary" sx={{ lineHeight: 1.5 }}>
                  {paso.sub}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Paper>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button
          tone="secondary"
          onClick={signOutAndRedirect}
          disabled={isSigningOut}
          data-testid="solicitud-en-revision-salir-button"
        >
          Salir
        </Button>
      </Box>
    </Box>
  );
};
